import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Save } from "lucide-react";
import AppShell from "../../components/AppShell";
import { api, formatErr } from "../../lib/api";
import { Card, FormRow } from "../../components/onboarding/adminUi";
import { btn } from "../../components/leads/PriorityBadge";

const SECTIONS = [
  ["principles", "Métodos y principios de entrenamiento", "Tu filosofía, cómo estructuras la temporada, qué priorizas…"],
  ["programming_criteria", "Criterios de programación", "Frecuencias, distribución según partidos, volumen/intensidad por día, orden de ejercicios…"],
  ["progression_rules", "Reglas de progresión y regresión", "Cuándo y cómo subes carga, criterios para retroceder…"],
  ["safety_rules", "Reglas de seguridad", "Qué evitar cerca del partido, ante dolor, en menores, sin supervisión…"],
  ["other", "Otros recursos y notas", "Cualquier otra referencia que la IA deba seguir"],
];
const EX_FIELDS = [["instructions", "Instrucciones técnicas"], ["variants", "Variantes"], ["progression", "Progresión"], ["regression", "Regresión"], ["equipment_alternatives", "Alternativas sin material"]];
const ta = { minHeight: 90, height: "auto", textTransform: "none", letterSpacing: 0 };

const ExerciseRow = ({ ex }) => {
  const [n, setN] = useState(ex.notes || {});
  const [open, setOpen] = useState(false);
  const save = async () => {
    try { await api.put(`/admin/methodology/exercises/${ex.id}`, Object.fromEntries(EX_FIELDS.map(([k]) => [k, n[k] || null]))); toast.success("Ejercicio guardado"); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const filled = EX_FIELDS.filter(([k]) => n[k]).length;
  return (
    <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", padding: "10px 0" }} data-testid={`meth-ex-${ex.id}`}>
      <button onClick={() => setOpen(!open)} style={{ background: "none", border: "none", color: "#fff", cursor: "pointer", width: "100%", textAlign: "left", display: "flex", justifyContent: "space-between", gap: 8 }} data-testid={`meth-ex-toggle-${ex.id}`}>
        <span><b>{ex.name}</b> <span style={{ color: "#737373", fontSize: 12 }}>{(ex.equipment || []).join(", ")}{ex.video_url ? " · vídeo ✓" : ""}</span></span>
        <span style={{ fontSize: 12, color: filled ? "#4ade80" : "#737373" }}>{filled}/{EX_FIELDS.length}</span>
      </button>
      {open && (
        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 10 }}>
          {EX_FIELDS.map(([k, l]) => (
            <FormRow key={k} label={l}><textarea className="qv-input" rows={2} style={{ ...ta, minHeight: 60 }} value={n[k] || ""} onChange={(e) => setN({ ...n, [k]: e.target.value })} data-testid={`meth-ex-${k}-${ex.id}`} /></FormRow>
          ))}
          <button style={btn("transparent")} onClick={save} data-testid={`meth-ex-save-${ex.id}`}><Save size={14} /> Guardar ejercicio</button>
        </div>
      )}
    </div>
  );
};

export default function AdminMethodology() {
  const [m, setM] = useState(null);
  const [exs, setExs] = useState([]);
  useEffect(() => {
    api.get("/admin/methodology").then((r) => setM(r.data)).catch((e) => toast.error(formatErr(e)));
    api.get("/admin/methodology/exercises").then((r) => setExs(r.data)).catch(() => {});
  }, []);
  const save = async () => {
    try { setM((await api.put("/admin/methodology", Object.fromEntries(SECTIONS.map(([k]) => [k, m[k] || ""])))).data); toast.success("Metodología guardada"); }
    catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <AppShell>
      <h1 style={{ fontFamily: "Bebas Neue, sans-serif", fontSize: "2rem", letterSpacing: "0.06em", margin: 0 }}>Mi metodología</h1>
      <p style={{ color: "#a3a3a3", fontSize: 13, margin: "4px 0 18px" }}>La IA usa esto como máxima prioridad al preparar cada borrador. Si un apartado está vacío, no lo inventa: te avisa.</p>
      {m && (
        <Card title="Métodos, criterios y reglas" testid="meth-card" right={<button style={btn("#dc2626")} onClick={save} data-testid="meth-save"><Save size={14} /> Guardar</button>}>
          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {SECTIONS.map(([k, l, ph]) => (
              <FormRow key={k} label={l}><textarea className="qv-input" rows={5} placeholder={ph} style={{ ...ta, minHeight: 130 }} value={m[k] || ""} onChange={(e) => setM({ ...m, [k]: e.target.value })} data-testid={`meth-${k}`} /></FormRow>
            ))}
          </div>
        </Card>
      )}
      <Card title={`Base de ejercicios · ${exs.length}`} testid="meth-exercises-card" right={<Link to="/app/admin/ejercicios" style={btn("transparent")} data-testid="meth-open-catalog">Añadir o editar ejercicios</Link>}>
        <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 6 }}>Completa instrucciones, variantes, progresiones y alternativas: la IA las usará al elegir ejercicios. Los vídeos y el material se gestionan en Ejercicios.</div>
        {exs.map((ex) => <ExerciseRow key={ex.id} ex={ex} />)}
      </Card>
    </AppShell>
  );
}
